//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
let d=[[],[[["keepinAreaList"],"SetKeepinAreas",{},1,0],[["keepoutAreaList"],"SetKeepoutAreas",{},1,0],[["otherAreaList"],"SetOtherAreas",{},1,0],[["copperAreaList"],"SetCopperAreas",{},1,0],[[],"PrintMapping",{},0,0]],[]];
SPLM.PcbExchange.AreaMappingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.AreaMappingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;